import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const LocalRoofingPage = lazy(() => import('../pages/services/local-roofing/page'));
const RoofInspectionPage = lazy(() => import('../pages/services/roof-inspection/page'));
const StormDamagePage = lazy(() => import('../pages/services/storm-damage/page'));
const AsphaltShinglePage = lazy(() => import('../pages/services/asphalt-shingle-roof/page'));
const InsuranceAdjusterPage = lazy(() => import('../pages/services/insurance-adjuster/page'));
const ShingleRoofsPage = lazy(() => import('../pages/services/shingle-roofs/page'));
const StormRestorationPage = lazy(() => import('../pages/services/storm-damage-restoration/page'));
const InsuranceRoofersPage = lazy(() => import('../pages/services/insurance-roofers/page'));
const RepairingAsphaltPage = lazy(() => import('../pages/services/repairing-asphalt-roof/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/local-roofing',
    element: <LocalRoofingPage />,
  },
  {
    path: '/services/roof-inspection',
    element: <RoofInspectionPage />,
  },
  {
    path: '/services/storm-damage',
    element: <StormDamagePage />,
  },
  {
    path: '/services/asphalt-shingle-roof',
    element: <AsphaltShinglePage />,
  },
  {
    path: '/services/insurance-adjuster',
    element: <InsuranceAdjusterPage />,
  },
  {
    path: '/services/shingle-roofs',
    element: <ShingleRoofsPage />,
  },
  {
    path: '/services/storm-damage-restoration',
    element: <StormRestorationPage />,
  },
  {
    path: '/services/insurance-roofers',
    element: <InsuranceRoofersPage />,
  },
  {
    path: '/services/repairing-asphalt-roof',
    element: <RepairingAsphaltPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;